import React from 'react'

/**
 * @typedef {{
 * bsbCode: string,
 * accountNumber: string,
 * accountNumberConfirmation: string,
 * accountName: string,
 * type: string,
 * }} BankAccountInformation
 */

/**
 * @typedef {{
 * bankAccountInformation: BankAccountInformation,
 * updateBankAccountField: (field: keyof BankAccountInformation, value: string) => void,
 * resetBankAccount: () => void,
 * isValidBecsBankAccount: boolean,
 * }} PaymentBecsBankAccountContextType
 */

const initialBankAccountState = {
  bsbCode: '',
  accountNumber: '',
  accountNumberConfirmation: '',
  accountName: '',
  type: 'becs',
}

const PaymentBecsBankAccountContext = React.createContext(
  /** @type {PaymentBecsBankAccountContextType} */ ({}),
)

export function PaymentBecsBankAccountProvider({children}) {
  const [bankAccountInformation, setBankAccountInformation] = React.useState(
    initialBankAccountState,
  )

  const updateBankAccountField = React.useCallback((field, value) => {
    setBankAccountInformation(prev => ({
      ...prev,
      [field]: value,
    }))
  }, [])

  const resetBankAccount = React.useCallback(() => {
    setBankAccountInformation(initialBankAccountState)
  }, [])

  const isValidBecsBankAccount = React.useMemo(() => {
    const {
      bsbCode,
      accountNumber,
      accountNumberConfirmation,
      accountName,
      type,
    } = bankAccountInformation

    return (
      bsbCode.length > 0 &&
      accountNumber.length > 0 &&
      accountNumberConfirmation.length > 0 &&
      accountNumber === accountNumberConfirmation &&
      type.length > 0 &&
      accountName.length > 0
    )
  }, [bankAccountInformation])

  const contextValue = React.useMemo(
    () => ({
      bankAccountInformation,
      updateBankAccountField,
      resetBankAccount,
      isValidBecsBankAccount,
    }),
    [
      bankAccountInformation,
      updateBankAccountField,
      resetBankAccount,
      isValidBecsBankAccount,
    ],
  )

  return (
    <PaymentBecsBankAccountContext.Provider value={contextValue}>
      {children}
    </PaymentBecsBankAccountContext.Provider>
  )
}

export function usePaymentBecsBankAccount() {
  console.log('inside becs payment context')
  const context = React.useContext(PaymentBecsBankAccountContext)
  if (!context) {
    throw new Error(
      'usePaymentBecsBankAccount must be used within a PaymentBankAccountProvider',
    )
  }
  return context
}
